import RenderModifLine from "./renderModifLine";

const RenderSubNoSouscategories = ({ sub, detail, setDetails, parentId, subcategories, entete }: { sub: any, detail: any, setDetails: any, parentId: any, subcategories: any, entete: any }) => {
    if (!sub) return null;
    return (
        <div key={sub.rpl_id} className={`subcategory`}>
            <p className="titleCategory">{sub.rpl_designation}</p>
            {
                <RenderModifLine sub={sub} detail={detail} setDetails={setDetails} parentId={parentId} subcategories={subcategories} />
            }
        </div>
    );
};
export default RenderSubNoSouscategories